// Shared toast API for givsum3 controllers. Markup lives in
// layouts/givsum3/_gv_toast_container.html.haml -- this file only fills in
// text/icon and drives bootstrap.Toast. Swapping the underlying toast engine
// later only means rewriting spawn() -- GvToast.success/error/warning/show stay the same.

const CONTAINER_ID = "gv-toast-stack"
const TEMPLATE_ID = "gv-toast-template"

const VARIANTS = {
  success: { alertClass: "alert-success", icon: "fa-check-circle" },
  error: { alertClass: "alert-danger", icon: "fa-exclamation-triangle" },
  warning: { alertClass: "alert-warning", icon: "fa-info-circle" }
}

function spawn(type, message, options) {
  const container = document.getElementById(CONTAINER_ID)
  const template = document.getElementById(TEMPLATE_ID)
  if (!container || !template) {
    console.error("GvToast: #gv-toast-stack/#gv-toast-template missing -- is layouts/givsum3/_gv_toast_container rendered?")
    return null
  }

  const variant = VARIANTS[type] || VARIANTS.success
  const node = template.content.firstElementChild.cloneNode(true)
  node.classList.add(variant.alertClass)
  node.querySelector(".alert-icon i").className = `fa ${options.icon || variant.icon}`
  node.querySelector(".alert-heading").textContent = message

  container.appendChild(node)

  const instance = new bootstrap.Toast(node, {
    autohide: options.autohide !== false,
    delay: options.duration || 3000
  })
  node.addEventListener("hidden.bs.toast", () => node.remove())
  instance.show()
  return instance
}

const GvToast = {
  show(message, options = {}) {
    return spawn(options.type || "success", message, options)
  },
  success(message, options = {}) {
    return spawn("success", message, options)
  },
  error(message, options = {}) {
    return spawn("error", message, options)
  },
  warning(message, options = {}) {
    return spawn("warning", message, options)
  }
}

export default GvToast
